import { Validators } from '@angular/forms';

export const INPUT_TYPES_CONFIG = {
  STRING: 'string',
  NUMBER: 'number',
  TEL: 'tel',
  RANGE_BETWEEN: 'range_between',
  MULTIPLE_STRING: 'multiple_string',
  SELECT_DATA_LIST: 'select_data_list',
  DATE: 'date',
  BOOLEAN: 'boolean',
  SELECT_SEARCH_DATA_LIST: 'select_search_data_list'
};

export const WTC_BOAT_SUBTIPES = {
  MOTORBOAT: 'MotorBoat',
  SAILBOAT: 'Sailboat',
  NOMOTORBOAT: 'NoMotorBoat'
};

export const CLAIM_PRODUCTS = {
  CAR: {
    nickname: 'CLAIM_PRODUCTS.CAR.CLAIM_NAME'
  },
  CAR_OTHER: {
    nickname: 'CLAIM_PRODUCTS.CAR_OTHER.CLAIM_NAME'
  },
  HOUSE: {
    nickname: 'CLAIM_PRODUCTS.HOUSE.CLAIM_NAME'
  },
  CONTENTS: {
    nickname: 'CLAIM_PRODUCTS.CONTENTS.CLAIM_NAME'
  },
  TRAVEL: {
    nickname: 'CLAIM_PRODUCTS.TRAVEL.CLAIM_NAME'
  },
  BOAT: {
    nickname: 'CLAIM_PRODUCTS.BOAT.CLAIM_NAME'
  },
  VALUABLES: {
    nickname: 'CLAIM_PRODUCTS.VALUABLES.CLAIM_NAME'
  },
  ANIMAL: {
    nickname: 'CLAIM_PRODUCTS.ANIMAL.CLAIM_NAME'
  },
  ACCIDENT: {
    nickname: 'CLAIM_PRODUCTS.ACCIDENT.CLAIM_NAME'
  },
  VACATION_HOME: {
    nickname: 'CLAIM_PRODUCTS.VACATION_HOME.CLAIM_NAME'
  },
  SNOWMOBILE: {
    nickname: 'CLAIM_PRODUCTS.SNOWMOBILE.CLAIM_NAME'
  },
  MOTORCYCLE: {
    nickname: 'CLAIM_PRODUCTS.MOTORCYCLE.CLAIM_NAME'
  },
  TRAILER_HOME: {
    nickname: 'CLAIM_PRODUCTS.TRAILER_HOME.CLAIM_NAME'
  },
  VETERAN_CAR: {
    nickname: 'CLAIM_PRODUCTS.VETERAN_CAR.CLAIM_NAME'
  },
  TRAILER: {
    nickname: 'CLAIM_PRODUCTS.TRAILER.CLAIM_NAME'
  },
  MOPED: {
    nickname: 'CLAIM_PRODUCTS.MOPED.CLAIM_NAME'
  },
  CAMPING_VAN: {
    nickname: 'CLAIM_PRODUCTS.CAMPING_VAN.CLAIM_NAME'
  },
  VACATION_HOME_ABROAD: {
    nickname: 'CLAIM_PRODUCTS.VACATION_HOME_ABROAD.CLAIM_NAME'
  }
};

export const CLAIM_PRODUCTS_SCOOPR = {
  CAR: {
    nickname: 'CLAIM_PRODUCTS.CAR.CLAIM_NAME'
  },
  CAR_OTHER: {
    nickname: 'CLAIM_PRODUCTS.CAR_OTHER.CLAIM_NAME'
  },
  HOUSE: {
    nickname: 'CLAIM_PRODUCTS.HOUSE.CLAIM_NAME'
  },
  CONTENTS: {
    nickname: 'CLAIM_PRODUCTS.CONTENTS.CLAIM_NAME'
  },
  TRAVEL: {
    nickname: 'CLAIM_PRODUCTS.TRAVEL.CLAIM_NAME'
  },
  BOAT: {
    nickname: 'CLAIM_PRODUCTS.BOAT.CLAIM_NAME'
  },
  VALUABLES: {
    nickname: 'CLAIM_PRODUCTS.VALUABLES.CLAIM_NAME'
  },
  ANIMAL: {
    nickname: 'CLAIM_PRODUCTS.ANIMAL.CLAIM_NAME'
  },
  ACCIDENT: {
    nickname: 'CLAIM_PRODUCTS.ACCIDENT.CLAIM_NAME'
  },
  VACATION_HOME: {
    nickname: 'CLAIM_PRODUCTS.VACATION_HOME.CLAIM_NAME'
  },
  SNOWMOBILE: {
    nickname: 'CLAIM_PRODUCTS.SNOWMOBILE.CLAIM_NAME'
  },
  MOTORCYCLE: {
    nickname: 'CLAIM_PRODUCTS.MOTORCYCLE.CLAIM_NAME'
  },
  TRAILER_HOME: {
    nickname: 'CLAIM_PRODUCTS.TRAILER_HOME.CLAIM_NAME'
  },
  VETERAN_CAR: {
    nickname: 'CLAIM_PRODUCTS.VETERAN_CAR.CLAIM_NAME'
  },
  TRAILER: {
    nickname: 'CLAIM_PRODUCTS.TRAILER.CLAIM_NAME'
  },
  MOPED: {
    nickname: 'CLAIM_PRODUCTS.MOPED.CLAIM_NAME'
  },
  CAMPING_VAN: {
    nickname: 'CLAIM_PRODUCTS.CAMPING_VAN.CLAIM_NAME'
  },
  VACATION_HOME_ABROAD: {
    nickname: 'CLAIM_PRODUCTS.VACATION_HOME_ABROAD.CLAIM_NAME'
  }
};

export const PROPERTY_GROUPS = ['INSURANCE_INFO', 'OBJECT_INFO'];

export const PRODUCT_STATUSES = {
  ADDED: 'ADDED',
  EDITED: 'EDITED',
  EXCLUDED: 'EXCLUDED',
  APPROVED: 'APPROVED',
  DELETED: 'DELETED',
};

export const OFFER_PRODUCT_SECTIONS = {
  CHANGED: 'changed',
  REGULAR: 'regular'
};
